import { apolloClient } from "../../vue-apollo";
import {
    GET_ESTADISTICA_FOLOVID,
    GET_VACUNAS_USUARIO,
    GET_TIPO_VACUNA,
    GET_ENCUESTAS_COVID

} from "../../graphql/queries";
import {
    CREAR_VACUNA_USUARIO,
    ELIMINAR_VACUNA_USUARIO,
    EDITAR_VACUNA_USUARIO,
    REPOTAR_SINTOMA
} from "../../graphql/mutations";

export default {
    namespaced: true,
    state: {
        EstadisticasApp: [],
        ListTipoVacunas: [],
        ListVacunasUsuario: [],
        EncuestaCovid: []
    },
    getters: {
    },
    mutations: {
        
        SET_ESTADISTICAS_FOLOVID(state, resultados){
            state.EstadisticasApp = resultados;
        },

        SET_TIPO_VACUNAS(state, vacunas){
            state.ListTipoVacunas = vacunas;
        },
        SET_LISTA_VACUNAS_USUARIO(state, lista){
            state.ListVacunasUsuario = lista;
        },
        SET_ENCUESTA_COVID(state, encuestaCovid){
            state.EncuestaCovid = encuestaCovid;
        },

        CRAR_DOSIS_USUARIO(state, vacunas){
            //let vacuna_index = state.ListVacunasUsuario.findIndex(dosis => dosis.id_vacuna == vacuna.id_vacuna);
            console.log("nueva vacuna: ", vacunas);
            state.ListVacunasUsuario = vacunas;
        },

        EDITA_DOSIS_USUARIO(state, edit_vacuna){
            state.ListVacunasUsuario = edit_vacuna;
        },

        ELIMINAR_DOSIS_USUARIO(state, vacuna){
            let vacuna_index = state.ListVacunasUsuario.findIndex(dosis => dosis.id_vacuna == vacuna.id_vacuna);
            if (vacuna_index != undefined) {
                //console.log('Comentario Encontrado', state.ListVacunasUsuario[vacuna_index]);
                state.ListVacunasUsuario.splice(vacuna_index, 1);
            }
        },
        RESPUESTA_ENCUESTA_SINTOMA(state, covidEncuesta){
            // let encuesta_covid_index = state.EncuestaCovid.findIndex(encuesta => encuesta.id_respuesta == covidEncuesta.id_respuesta);
            // if (encuesta_covid_index != undefined) {
            //     //console.log('Comentario Encontrado', state.ListVacunasUsuario[vacuna_index]);
            //     state.EncuestaCovid.splice(encuesta_covid_index, 1);
            // }
            console.log("falso: ",covidEncuesta);
        }

    },
    actions: {
        async getEstadisticaEmpresa({ commit }, data_) {
            let response = null;
            let params = {
                query: GET_ESTADISTICA_FOLOVID,
                variables: data_
            }
            try {
            await apolloClient.query(params).then(res => {
                //console.log("respuest de server EstadisticasApp: ", res.data.EstadisticasApp);
                if (!res.loading) response = res.data.EstadisticasApp;
            });
            }
            catch(e){
            console.log("Falla error, getEstadisticaEmpresa ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    if (response.length==0){
                        resolve(false);
                    }
                    else {
                        resolve(response);
                        commit("SET_ESTADISTICAS_FOLOVID", response);
                    }
                }
                else {
                    resolve(false);
                }
            });
        },

        async getTipoVacuna({ commit }, data_){
            let response = null;
            let params = {
                query: GET_TIPO_VACUNA,
                variables: data_
            }
            try {
            await apolloClient.query(params).then(res => {
                //console.log("respuest de server ListTipoVacunas: ", res.data.ListTipoVacunas);
                if (!res.loading) response = res.data.ListTipoVacunas;
            });
            }
            catch(e){
            console.log("Falla error, getTipoVacuna ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    if (response.length==0){
                        resolve(false);
                    }
                    else {
                        resolve(response);
                        commit("SET_TIPO_VACUNAS", response);
                    }
                }
                else {
                    resolve(false);
                }
            });
            
        },

        async getListaVacunasUsuario({ commit }, data_){
            let response = null;
            let params = {
                query: GET_VACUNAS_USUARIO,
                variables: data_
            }
            try {
            await apolloClient.query(params).then(res => {
                //console.log("respuest de server ListVacunasUsuario: ", res.data.ListVacunasUsuario);
                if (!res.loading) response = res.data.ListVacunasUsuario;
            });
            }
            catch(e){
            console.log("Falla error, getListaVacunasUsuario ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    if (response.length==0){
                        resolve(false);
                    }
                    else {
                        resolve(response);
                        commit("SET_LISTA_VACUNAS_USUARIO", response);
                    }
                }
                else {
                    resolve(false);
                }
            });
            
        },

        async getEncuestaCovid({ commit }, data_){
            let response = null;
            let params = {
                query: GET_ENCUESTAS_COVID,
                variables: data_
            }
            try {
            await apolloClient.query(params).then(res => {
                console.log("respuest de server EncuestaCovid: ", res.data.EncuestaCovid);
                if (!res.loading) response = res.data.EncuestaCovid;
            });
            }
            catch(e){
            console.log("Falla error, getEncuestaCovid ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    if (response.length==0){
                        resolve(false);
                    }
                    else {
                        resolve(response);
                        commit("SET_ENCUESTA_COVID", response);
                    }
                }
                else {
                    resolve(false);
                }
            });
            
        },

        async creaVacunaUsuario({ commit }, data_){
            let response = null;
            let data = [];
            let params = {
                mutation: CREAR_VACUNA_USUARIO,
                variables: data_
            }
            try{
                await apolloClient.mutate(params).then(res => {
                    console.log('creaVacunaUsuario', res.data.CreateDosisVacuna);
                    if (!res.loading) data = res.data.CreateDosisVacuna;
                    response = data;
                });
            }
            catch(e){
                console.log("Falla metodo creaVacunaUsuario: ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    commit("CRAR_DOSIS_USUARIO", response);
                    resolve(response);
                }
                else {
                resolve(false);
                }
        
            });
        },

        async editarVacunaUsuario({ commit }, data_){
            let response = null;
            let data = [];
            let params = {
                mutation: EDITAR_VACUNA_USUARIO,
                variables: data_
            }
            try{
                await apolloClient.mutate(params).then(res => {
                    //console.log('responderEncuesta', res.data.EditDosisVacuna);
                    if (!res.loading) data = res.data.EditDosisVacuna;
                    response = data;
                });
            }
            catch(e){
                console.log("Falla metodo editarVacunaUsuario: ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    resolve(response);
                    commit("EDITA_DOSIS_USUARIO", response);
                }
                else {
                resolve(false);
                }
        
            });
        },

        async eliminarVacunaUsuario({ commit }, data_){
            let response = null;
            let data = [];
            let params = {
                mutation: ELIMINAR_VACUNA_USUARIO,
                variables: data_
            }
            try{
                await apolloClient.mutate(params).then(res => {
                    //console.log('DeleteVacuna', res.data.DeleteVacuna);
                    if (!res.loading) data = res.data.DeleteVacuna;
                    response = data;
                });
            }
            catch(e){
                console.log("Falla metodo eliminarVacunaUsuario: ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    resolve(response);
                    commit("ELIMINAR_DOSIS_USUARIO", response);
                }
                else {
                resolve(false);
                }
        
            });
        },

        async reportaSintoma({ commit }, data_){
            let response = null;
            let data = [];
            let params = {
                mutation: REPOTAR_SINTOMA,
                variables: data_
            }
            try{
                await apolloClient.mutate(params).then(res => {
                    //console.log('ReportarSintomas', res.data.ReportarSintomas);
                    if (!res.loading) data = res.data.ReportarSintomas;
                    response = data;
                });
            }
            catch(e){
                console.log("Falla metodo reportaSintoma: ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    resolve(response);
                    commit("RESPUESTA_ENCUESTA_SINTOMA", response);
                }
                else {
                resolve(false);
                }
        
            });
        },
    }
};